module.exports = __webpack_public_path__ + "static/img/20181.6a5350f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20181.jpg
// module id = bERl
// module chunks = 1